import { FC } from 'react'
import { ReactComponent as PlusIcon } from 'src/assets/svg/plus.svg'
import { Card } from 'src/components/Card'
import styles from './reviewAnalysisWidget.module.scss'

interface ReviewAnalysisWidgetProps {
  // The whole page (a campaign with no platforms yet): the card fills the
  // viewport and centres its content, as in the design.
  fullPage?: boolean
  onAddPlatform?: () => void
}

export const ReviewAnalysisWidget: FC<ReviewAnalysisWidgetProps> = ({
  fullPage = false,
  onAddPlatform,
}) => {
  return (
    <Card className={`${styles.card} ${fullPage ? styles.cardFullPage : ''}`}>
      <div className={styles.header}>
        <span className={styles.title}>Review Analysis</span>
        <button className={styles.tooltipButton} type="button">
          <span className={styles.tooltipIcon}>?</span>
        </button>
      </div>

      <div className={styles.emptyState}>
        <div className={styles.iconWrapper}>
          <img alt="star" src="/star.svg" />
        </div>

        <h2 className={styles.emptyTitle}>Start analyzing customer reviews</h2>

        <p className={styles.emptyDescription}>
          Add your business location from Google Maps, TripAdvisor, Booking,
          Expedia or other <br /> review platforms to see ratings, sentiment
          insights, and review trends in one place. <br /> You&apos;ll get a
          complete view of customer feedback across all platforms.
        </p>

        <button
          className={styles.addButton}
          onClick={onAddPlatform}
          type="button"
        >
          <PlusIcon className={styles.addIcon} />
          Add Review Platform
        </button>
      </div>
    </Card>
  )
}
